import { useNavigate } from "react-router-dom"
import '../../css/Unauthorized.css'
//Translation
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

const Unauthorized = ({ isNavOpen }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    return (
        <div className={`${isNavOpen ? 'body-squeezed' : 'body'}`}>
            <div className="unauthorized">
                <div className="unauthorized-title">{t('unauthorized.title')}</div>
                <br />
                <p>{t('unauthorized.message')}</p>
                <br />
                <p>
                    <Trans
                        i18nKey="unauthorized.message2"
                        components={[
                            <a href="mailto:manuel.casanova@dnzify.com"
                                style={{ color: 'inherit', textDecoration: 'underline' }}
                            />
                        ]}
                    />
                </p>
                <br />

                <div>
                    <button className="unauthorized-go-back" onClick={goBack}>{t('unauthorized.goBack')}</button>
                </div>
            </div>
        </div>
    )
}

export default Unauthorized
